import { MEDIA_UPLOAD_MIN_BYTES as e, UPLOADABLE_IMAGE_TYPES as t } from "@maat/api-main/types";
//#region src/properties/media/mediaUploadPlan.ts
var n = (n, r) => {
	let i = [], a = [];
	for (let o of n) {
		let n = [];
		for (let i of o.files) t.includes(i.type) ? !Number.isFinite(i.size) || i.size <= 0 ? a.push({
			category: o.category,
			name: i.name,
			reason: "unknown_size"
		}) : i.size > r ? a.push({
			category: o.category,
			name: i.name,
			reason: "too_large",
			maxBytes: r
		}) : i.size < e ? a.push({
			category: o.category,
			name: i.name,
			reason: "too_small",
			maxBytes: r
		}) : n.push(i) : a.push({
			category: o.category,
			name: i.name,
			reason: "unsupported_type",
			maxBytes: r
		});
		n.length > 0 && i.push({
			category: o.category,
			space_index: o.space_index,
			files: n
		});
	}
	return {
		accepted: i,
		skipped: a
	};
}, r = (e) => e.map((e) => ({
	category: e.category,
	...typeof e.space_index == "number" ? { space_index: e.space_index } : {},
	files: e.files.map((e) => ({
		content_type: e.type,
		size: e.size
	}))
})), i = (e, t) => {
	let n = /* @__PURE__ */ new Map();
	for (let e of t) {
		let t = n.get(e.category);
		t ? t.push(...e.files) : n.set(e.category, [...e.files]);
	}
	let r = [];
	for (let t of e) {
		let e = n.get(t.category)?.shift();
		e && r.push({
			upload: t,
			file: e,
			category: t.category
		});
	}
	let i = [];
	for (let [e, t] of n) for (let n of t) i.push({
		category: e,
		name: n.name,
		reason: "unknown_category"
	});
	return {
		matched: r,
		unattributed: i
	};
}, a = (e, t) => {
	let n = [], r = (r, i) => {
		if (!t || !(i > (n[r] ?? 0))) return;
		n[r] = i;
		let a = n.reduce((e, t) => e + (t ?? 0), 0);
		t({
			loaded: Math.min(a, e),
			total: e
		});
	};
	return {
		onFileProgress: (e, t) => r(e, t),
		onFileSettled: (e, t) => r(e, t)
	};
};
//#endregion
export { r as buildPresignMedia, a as createProgressAggregator, i as matchUploadsToFiles, n as partitionUploadable };
